import React from 'react';
import { Col, Fill, ScrollCol } from '../../components/RowCol';
import { getLocalState, setLocalState } from '../../localState';
import FinalJeopardyEditor from './FinalJeopardyEditor';
import Spacer from '../../components/Spacer';
import RoundEditorLayout from './RoundEditorLayout';
import BoardEditor from './BoardEditor';
import ConfirmableButton from '../../components/ConfirmableButton';
import LocalFileStorage from '../../LocalFileStorage';

type Props = {};
type State = {};

export type EditFunction = (
	editPath: (string | number)[],
	editType: 'edit' | 'insert_element' | 'delete_element' | 'delete_field',
	value?: any,
) => void;

class GameEditor extends React.Component<Props, State> {
	readonly db: LocalFileStorage;

	constructor(props: Props) {
		super(props);

		this.db = new LocalFileStorage();
	}

	storageUpdate = () => this.forceUpdate();

	componentDidMount() {
		this.db.init().then(() => this.forceUpdate());

		window.addEventListener('storage', this.storageUpdate);
	}

	componentWillUnmount() {
		window.removeEventListener('storage', this.storageUpdate);
	}

	editRound = (roundIndex: number) =>
		(
			editPath: (string | number)[],
			editType: 'edit' | 'insert_element' | 'delete_element' | 'delete_field',
			value?: any,
		) => {
			const { rounds } = getLocalState();
			const round = rounds[roundIndex];
			if (editType === 'edit') {
				let pointer = round;
				for (let i = 0; i < editPath.length - 1; i++) {
					const key = editPath[i];
					// @ts-ignore
					pointer = pointer[key];
				}
				const lastKey = editPath[editPath.length - 1];
				// @ts-ignore
				pointer[lastKey] = value;

				setLocalState('rounds', rounds);
				this.forceUpdate();
				return;
			}

			if (editType === 'delete_field') {
				let pointer = round;
				for (let i = 0; i < editPath.length - 1; i++) {
					const key = editPath[i];
					// @ts-ignore
					pointer = pointer[key];
				}
				const lastKey = editPath[editPath.length - 1];
				// @ts-ignore
				delete pointer[lastKey];

				setLocalState('rounds', rounds);
				this.forceUpdate();
				return;
			}

			if (editType === 'delete_element') {
				let pointer = round;
				for (let i = 0; i < editPath.length - 1; i++) {
					const key = editPath[i];
					// @ts-ignore
					pointer = pointer[key];
				}
				const lastKey = editPath[editPath.length - 1];
				// @ts-ignore
				pointer.splice(lastKey, 1);

				setLocalState('rounds', rounds);
				this.forceUpdate();
				return;
			}

			if (editType === 'insert_element') {
				let pointer = round;
				for (let i = 0; i < editPath.length - 1; i++) {
					const key = editPath[i];
					// @ts-ignore
					pointer = pointer[key];
				}
				const lastKey = editPath[editPath.length - 1];
				// @ts-ignore
				pointer.splice(lastKey, 0, value);

				setLocalState('rounds', rounds);
				this.forceUpdate();
				return;
			}
		};

	render() {
		const { rounds } = getLocalState();
		return (
			<Fill>
				<ScrollCol fill styleInner={{
					color: 'white',
					padding: '50px',
					minWidth: '1615px',
				}}>
					{rounds.map((round, roundIndex) => {
						let roundName = '';
						if ('finalJeopardy' in round) {
							roundName = 'Final Jeopardy (Round 3)';
						} else if (roundIndex === 0) {
							roundName = 'Single Jeopardy (Round 1)';
						} else if (roundIndex === 1) {
							roundName = 'Double Jeopardy (Round 2)';
						}

						return (
							<div key={roundIndex}>

								<RoundEditorLayout
									roundName={roundName}
								>
									{'finalJeopardy' in round ? (
										<FinalJeopardyEditor
											category={round.category}
											question={round.question}
											editRound={this.editRound(roundIndex)}
											localFileStorage={this.db}
										/>
									) : (
										<BoardEditor
											categories={round.categories}
											levels={round.levels}
											editRound={this.editRound(roundIndex)}
											localFileStorage={this.db}
										/>
									)}
								</RoundEditorLayout>
								<Spacer vertical={100} />
							</div>
						);
					})}

					<Col justifyStart style={{
						alignSelf: 'flex-start',
					}}>
						<ConfirmableButton
							label="Reset All"
							onClick={() => {
								localStorage.clear();
								this.forceUpdate();
							}}
						/>
					</Col>
				</ScrollCol>
			</Fill>
		);
	}
}

export default GameEditor;
